import './audio-player';
import * as BucketTools from "./bucket";

export function buscador() {
    $('button[data-id="btnBuscador"]').on('click', function() {
        window.location.href = window.config.Statics.BuscadorUrl + $('input[data-id="buscador"]').val();
    });
    $('input[data-id="buscador"]').on('keypress', function(e) {
        if (e.keyCode == 13) {
            $('button[data-id="btnBuscador"]').click();
        }
    });
}

export const functions = () => {

    var $window = $(window);
    modal();
    encuesta();
    //colorMobile();
    headerFijo();
    arriba();
    menu();
    menuBusqueda();
    modalOut();
    fotoXL();
    audioPlayer();
    //slider(); //TODO: esto solo se usa para HTMLs de integracion
    headerFijoHome();
    comentarioScroll();
    videoFixed();
    //animaciones();

    function encuesta() {
        var opcion = $('#item-nota #nota #cuerpo .encuesta button');
        var encuesta = $('#item-nota #nota #cuerpo .encuesta');

        opcion.click(function() {

            if (encuesta.hasClass('resultados')) {} else {
                $(this).addClass('elegido');
                encuesta.addClass('resultados');

                opcion.each(function() {
                    let opcionAfter = $(this).find('span');
                    let porcentaje = opcionAfter.html();
                    opcionAfter.css('width', porcentaje);
                });
            }
        })
    }


    function headerFijo() {
        if ($(window).width() > 767) {
            if ($('h1.titulo') && $('h1.titulo').length > 0) {
                var titulo = $('h1.titulo')[0].textContent;
                document.querySelector('.titulo-fijo').innerHTML = titulo;
            }

        } else {
            if (document.querySelector('.titulo-fijo')) {
                document.querySelector('.titulo-fijo').innerHTML = '';
            }

        }


        $(window).scroll(function() {
            if (checkVisible($('.titulo'))) {
                $("header").removeClass("headerFijo");
            } else {
                $("header").addClass("headerFijo");
            }
        });

        function checkVisible(elm, evalparam) {
            var evalparam = evalparam || "visible";
            var vpH = $(window).height(), // Viewport Height
                st = $(window).scrollTop(), // Scroll Top
                y = $(elm).offset().top,
                elementHeight = $(elm).height();

            if (evalparam === "visible") return ((y < (vpH + st)) && (y > (st - elementHeight)));
            if (evalparam === "above") return ((y < (vpH + st)));
        }
    }

    function headerFijoHome() {
        // Oculta header cuando el usuario scrollea hacia abajo y lo muestra cuando scrollea hacia arriba
        let didScroll;
        let lastScrollTop = 0;
        let delta = 5;
        let navbarHeight = $('header').outerHeight();

        $(window).scroll(function(event) {
            didScroll = true;
        });

        setInterval(function() {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            let st = $(window).scrollTop();

            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > navbarHeight) {
                // Scroll Down
                $('header').removeClass('nav-down').addClass('nav-up');
            } else {
                // Scroll Up
                if (st + $(window).height() < $(document).height()) {
                    $('header').removeClass('nav-up').addClass('nav-down');
                }
            }

            if ($(window).width() < 1024 && $("#item-nota").length) {
                let cuerpo = ($('#nota').offset().top) + 70;
                if (st > lastScrollTop || $(window).scrollTop() < cuerpo) {
                    $('.scroll-links').slideUp(200);
                } else {
                    // Scroll Up
                    if (st + $(window).height() < $(document).height()) {
                        $('.scroll-links').slideDown(200);
                    }
                }
            }
            if (st > 180) {

                if ($('header').hasClass('nav-down')) {
                    $('.banner-mobile.sticky2, .banner.sticky2').removeClass('up');
                } else {
                    $('.banner-mobile.sticky2, .banner.sticky2').addClass('up');
                }

            }

            lastScrollTop = st;

        }

        /*$(".scroll-links a").on('click', function(event) {
            if (this.hash !== "") {
                event.preventDefault();
                let hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function() {
                    window.location.hash = hash;
                });
            }
        });*/
    }





    function arriba() {
        $(".volver").click(function(event) {
            event.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, 600);
            return false;
        });
    };

    function comentarioScroll() {
        if ($("#livefyre").length > 0) {
            $('[data-id="comentarios"]').click(function(event) {
                event.preventDefault();
                $("html, body").animate({ scrollTop: $("#livefyre").offset().top }, 600);
                return false;
            });
        }
    }



    function modal() {
        var modal = $('#modalImagen');
        var ampliar = $('.galeria img, figure img');
        var cerrar = $('#cuerpo .icon-cerrar');

        //Abre Modal
        ampliar.click(function() {
            let sliderContainer = $('body').find('#sliderContainer');

            if ($(this).parent().parent().parent().is('#sliderContainer')) {
                for (let img of sliderContainer.find('ul li img')) {

                    var alturaImagen = window.screen.height;
                    $(this).parent().find("img").css('display', 'none');
                    img.src = BucketTools.changeSizeWithFullPath(img.src, 'h' + alturaImagen);
                    $('#sliderContainer').find('ul').addClass('elementoModal');
                    $('#slider').addClass('top');
                    $(this).parent().find("img").fadeIn();
                };

            } else {
                let parentReal = $(this).parent().parent();

                parentReal.find("img").addClass('previa');
                parentReal.find('img.previa').clone().attr('class', 'nueva').appendTo(parentReal);
                parentReal.find("img.nueva").attr("src", "");
                var alturaImagen = window.screen.height;
                parentReal.find("img.nueva").attr("src", BucketTools.changeSizeWithFullPath(parentReal.find("img.previa").attr("src"), 'h' + alturaImagen));
                parentReal.addClass('elementoModal');
                parentReal.find("img").fadeIn();
            }

            if ($("body").hasClass('modal-on')) {} else {
                setTimeout(function() {
                    var elem = document.body; // Make the body go full screen.
                    requestFullScreen(elem);
                }, 0);
                modal.fadeIn(500);
                $('body').addClass('modal-on');
                $('.modal-on figcaption').fadeOut(0);
                $('.modal-on .elementoModal + figcaption, .modal-on .elementoModal > figcaption').fadeIn(500);


            }
        });

        cerrar.click(function() {
            if ($("body").hasClass('modal-on')) {
                exitFullScreen(elem);
                setTimeout(function() {
                    modal.fadeOut();
                    $('img').removeClass('previa');
                    $('img.nueva').remove();
                    $('body').removeClass('modal-on');
                    $('body').find('.elementoModal').removeClass('elementoModal');
                    $('#slider').removeClass('top');
                }, 0);
                var elem = document.body; // Make the body go full screen.

                $('.modal-on figcaption').fadeIn(0);
            } else {}
        });



    }

    // Fullscreen on
    function requestFullScreen(element) {
        // Supports most browsers and their versions.
        var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

        if (requestMethod) { // Native full screen.
            requestMethod.call(element);
        } else if (typeof window.ActiveXObject !== "undefined") { // Older IE.
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
    }

    // Fullscreen off
    function exitFullScreen(element) {
        if (document.exitFullscreen) {
            document.exitFullscreen();
            setTimeout(function() {
                modal.fadeOut();
                $('img').removeClass('previa');
                $('img.nueva').remove();
                $('body').removeClass('modal-on');
                $('body').find('.elementoModal').removeClass('elementoModal');
                $('#slider').removeClass('top');

            }, 300);
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }

    function modalOut() {

        var modal = $('#modalImagen');

        $(document).keyup(function(e) {
            if (e.which == 27)
                setTimeout(function() {
                    modal.fadeOut();
                    $('img').removeClass('previa');
                    $('img.nueva').remove();
                    $('body').removeClass('modal-on');
                    $('body').find('.elementoModal').removeClass('elementoModal');
                    $('#slider').removeClass('top');
                }, 300);
        });


        //Mousewheel abajo
        $(window).on('mousewheel', function(turn, delta) {

            if ($("figure").hasClass('elementoModal')) {
                if (delta == 1);
                else
                    setTimeout(function() {
                        modal.fadeOut();
                        $('img').removeClass('previa');
                        $('img.nueva').remove();
                        $('body').removeClass('modal-on');
                        $('body').find('.elementoModal').removeClass('elementoModal');
                        $('#slider').removeClass('top');
                    }, 300);

                var elem = document.body; // Make the body go full screen.
                exitFullScreen(elem);

                return true;
            } else {

            }

        });
    }




    function menu() {
        $(".icon-menu-desktop").unbind().click(function(event) {
            if ($('header').hasClass('desplegado')) {
                $('.icon-menu-desktop').html('MENÚ');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            } else {
                $('header').addClass('desplegado');
                $('.icon-menu-desktop').html('CERRAR');
            }
            if ($('header').hasClass('desplegado-busqueda') && $('.icon-menu-desktop').html('CERRAR')) {
                $('.icon-menu-desktop').html('MENÚ');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            }


            if ($(window).width() < 1024) {
                if ($('body').hasClass('sinScroll')) {
                    $('body').removeClass('sinScroll');
                } else {
                    $('body').addClass('sinScroll');
                }
            }



        });

        //Cierre del menú

        $('html').click(function(e) {
            if (e.target.id != 'header' && $(e.target).parents('header').length == 0) {
                $('.icon-menu-desktop').html('MENÚ');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            }
        })
    }

    function menuBusqueda() {
        $('.busqueda input').focus(function() {
            /*$('header').addClass('desplegado-busqueda');
            $('header').removeClass('desplegado');
            $('.icon-menu-desktop').html('CERRAR');*/
        })

    }

    function fotoXL() {
        if ($(window).width() < 768) {
            $(".scroll").each(function() {
                var contenedor = $(this).children("img").width();
                var scroll = $(this).width();
                var diferencia = (contenedor - scroll) / 2;
                if ($(this).hasClass("centrado")) {
                    $(this).scrollLeft(diferencia);
                }
                /*if ($(this).hasClass("derecha")) {
                    $(this).scrollLeft(0);
                }
                if ($(this).hasClass("izquierda")) {
                    $(this).scrollLeft(scroll);
                }*/
            });
        }
    }

    function audioPlayer() {
        $('.audio-player').mediaPlayer();
    }


    function colorNotaMobile(hex) {
        //Paso de HEX a RGB
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        var r = parseInt(result[1], 16);
        var g = parseInt(result[2], 16);
        var b = parseInt(result[3], 16);

        //Convierto de RGB a YIQ 
        var yiq = (r * 299 + g * 587 + b * 114) / 1000;
        var colorRGB = "rgb(" + r + "," + g + "," + b + ")";
        var foto = $("#cuerpo figure.XL img");
        var extra = 200;

        var alto = foto.offset().top + foto.height() + extra; //hardcode: por el banner sticky

        //Si el color es muy claro lo dejo blanco
        if (yiq < 190) {
            $("body").addClass("predomina-oscuro");
            if (!$(".background").length) {
                $("body").prepend("<div class='background'></div>");
            }
            $(".background").css({ "height": alto });
            $(".background").css({ "margin-top": "-" + extra + "px" });
            $(".background").css({ backgroundColor: colorRGB });
            $(".predomina-oscuro #cabezal").css({ backgroundColor: colorRGB });
        };

    }


    function borrarColorNotaMobile() {
        $("body").removeClass("predomina-oscuro");
        $(".background").remove();
        $("#cabezal").removeAttr("style");
    }



    //ESTO SOLO VA EN NOTA
    //COLORES EJEMPLOS oscuro 878E9A y claro D9D1CE:
    var colorPredominante = document.querySelector("div[data-colorPredominante]");
    colorPredominante = (colorPredominante != null) ? colorPredominante.getAttribute("data-colorPredominante") : null;

    $(document).ready(function() {
        if (!$('.storytelling').length && colorPredominante != null && colorPredominante != "") {
            if (window.innerWidth < 767) {
                colorNotaMobile(colorPredominante);
            }
        }
    });

    $(window).resize(function() {
        if (!$('.storytelling').length && colorPredominante != null && colorPredominante != "") {
            if (window.innerWidth < 767) {
                colorNotaMobile(colorPredominante);
            } else {
                borrarColorNotaMobile();
            }
        }
    })


    //Start - INHABILITA :HOVER en MOBILE
    function hasTouch() {
        return 'ontouchstart' in document.documentElement ||
            navigator.maxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0;
    }

    if (hasTouch()) { // remove all :hover stylesheets
        try { // prevent exception on browsers not supporting DOM styleSheets properly
            for (var si in document.styleSheets) {
                var styleSheet = document.styleSheets[si];
                if (!styleSheet.rules) continue;

                for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                    if (!styleSheet.rules[ri].selectorText) continue;

                    if (styleSheet.rules[ri].selectorText.match(':hover')) {
                        styleSheet.deleteRule(ri);
                    }
                }
            }
        } catch (ex) {}
    }
    //End - INHABILITA :HOVER en MOBILE

}


function animaciones() {

    (function($, win) {
        $.fn.inViewport = function(cb) {
            return this.each(function(i, el) {
                function visPx() {
                    let H = $(this).height(),
                        r = el.getBoundingClientRect(),
                        t = r.top,
                        b = r.bottom;
                    return cb.call(el, Math.max(0, t > 0 ? H - t : (b < H ? b : H)));
                }
                visPx();
                $(win).on("load resize scroll", visPx);
            });
        };
    }(jQuery, window));



    setTimeout(function() {
        $("#item-nota #nota #cuerpo .textual, #item-nota #nota #cuerpo .destacado, #item-nota.storytelling #nota .encabezado>div>div, #item-nota #mas-notas .puede-interesar div div .nota, #item-nota #mas-notas .puede-interesar div.fila-3 .nota, #item-nota #nota .link-boton a").inViewport(function(px) {
            if (px) $(this).addClass("animated");
            if (px) $(this).addClass("fadeInUp");
        });
        $("#item-nota #nota #cuerpo .XL img,#item-nota #nota #cuerpo .L img, #item-nota.storytelling .encabezado figure img").inViewport(function(px) {
            if (px) $(this).addClass("animated");
            if (px) $(this).addClass("fadeIn");
        });

        $("#item-nota #nota #cuerpo .S div, .XL.caja-destacada.epigrafe, #item-nota #nota #cuerpo .ademas .nota").inViewport(function(px) {
            if (px) $(this).addClass("animated");
            if (px) $(this).addClass("fadeInLeftShort");
        });

        $(".deportes .encabezado .techo-1 h3 a, #acumulado .encabezado h1").inViewport(function(px) {
            if (px) $(this).addClass("animated");
            if (px) $(this).addClass("underline");

            setTimeout(function() {
                $('.deportes .encabezado .techo-1 h3 a, #acumulado .encabezado h1').addClass('now');
            }, 1500);
        });
    }, 1);
}











function videoFixed() {

    if ($(window).width() >= 1024) {
        let videoid = 0;
        //toma el evento click y graba el id cuando es clickeado en la lista de videos (<a>)
        $(document).on('click', '.playlist-generico a', function(e) {
            e.preventDefault();
            if ($(".jwplayer.jw-flag-ads.jw-state-playing").length > 0) {
                jwplayer(videoid).pause();
            } else {
                jwplayer(videoid).stop();
            }
            $("#" + videoid).removeClass("fixedVideo");
            $(".contenedor-video-fixed").css("display", "none");
            $("#" + videoid).addClass("defaultVideo");

            $("#" + videoid + " .jw-skip").removeClass("omitirShow");
            $("#" + videoid + " .jw-skip").addClass("omitirHide");

            videoid = $(this).parent().prev().attr('id');

            $("#" + videoid + " .jw-skip").removeClass("omitirHide");
            $("#" + videoid + " .jw-skip").addClass("omitirShow");
        });

        //Prevalece el efecto fixed cuando se clickea en los controladores (play)
        $(document).on('click', '.jw-flag-ads.fixedVideo.jw-state-playing', function() {
            videoid = $(this).attr('id');
            jwplayer(videoid).pause();
        });

        //Prevalece el efecto fixed cuando se clickea en los controladores (pause)
        $(document).on('click', '.jw-flag-ads.fixedVideo.jw-state-paused', function() {
            videoid = $(this).attr('id');
            jwplayer(videoid).stop();
        });

        //toma el evento click y graba el id cuando el video esta en ads, con todas sus variables probables
        $(document).on('click', '.jw-flag-ads.defaultVideo', function() {

            if ($("#" + videoid + ".jw-flag-ads").length > 0) {

                $("#" + videoid + " .jw-skip").removeClass("omitirShow");
                $("#" + videoid + " .jw-skip").addClass("omitirHide");

                if ($("#" + videoid + ".fixedVideo.jwplayer.jw-state-paused").length > 0) {
                    jwplayer(videoid).stop();
                    $("#" + videoid).removeClass("fixedVideo");
                    $(".contenedor-video-fixed").css("display", "none");
                    $("#" + videoid).addClass("defaultVideo");

                } else if ($("#" + videoid + ".fixedVideo.jwplayer.jw-state-playing").length > 0) {
                    jwplayer(videoid).pause();
                    $("#" + videoid).removeClass("fixedVideo");
                    $(".contenedor-video-fixed").css("display", "none");
                    $("#" + videoid).addClass("defaultVideo");
                } else if ($("#" + videoid + ".jwplayer.jw-state-playing").length > 0) {
                    jwplayer(videoid).pause();

                } else if ($("#" + videoid + ".jwplayer.jw-state-paused").length > 0) {
                    jwplayer(videoid).stop();
                }

            } else if ($("#" + videoid + ".jw-state-playing").length > 0 || $(".jwplayer.jw-state-paused").length > 0) {
                jwplayer(videoid).stop();
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
            }
            $("#" + videoid + " .jw-skip").removeClass("omitirShow");
            $("#" + videoid + " .jw-skip").addClass("omitirHide");

            videoid = $(this).attr('id');

            $("#" + videoid + " .jw-skip").removeClass("omitirHide");
            $("#" + videoid + " .jw-skip").addClass("omitirShow");
        });

        //toma el evento click y graba el id del video (sin ads)
        $(document).on('click', '.jw-state-buffering', '.jw-state-playing', function() {

            $("#" + videoid + " .jw-skip").removeClass("omitirShow");
            $("#" + videoid + " .jw-skip").addClass("omitirHide");

            if ($("#" + videoid + ".jw-flag-ads.jw-state-playing").length > 0) {
                jwplayer(videoid).pause();
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
                videoid = $(this).attr('id');

            } else if ($("#" + videoid + ".jwplayer.jw-state-playing").length > 0 || $(".jwplayer.jw-state-paused").length > 0 || $(".jwplayer.jw-state-complete").length > 0 || $(".jwplayer.jw-flag-ads.jw-state-paused").length > 0 || $(".jwplayer.jw-state-buffering").length > 1) {
                jwplayer(videoid).stop();
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
                videoid = $(this).attr('id');

            } else if ($(".jwplayer.jw-flag-ads.jw-state-buffering").length > 1) {
                jwplayer(videoid).pause();
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
                videoid = $(this).attr('id');
            } else {
                videoid = $(this).attr('id');
            }

        });

        //animacion con el scroll ya tomado el id
        $(window).scroll(function() {
            function VideoDefault() {
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
            };

            function VideoFixed() {
                $("#" + videoid).addClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "block");
                $("#" + videoid).removeClass("defaultVideo");
            };

            //segun estado del video
            if ($("#" + videoid + ".jwplayer.jw-state-playing").length > 0 || $("#" + videoid + ".jwplayer.jw-state-paused").length > 0 || $("#" + videoid + ".jwplayer.jw-flag-ads.jw-state-playing").length > 0 || $(".jwplayer.jw-state-buffering").length > 0) {

                let limiteTop = $("#" + videoid).parent().offset().top;
                let limiteBottom = limiteTop + $("#" + videoid).height();
                let documento = $(document).scrollTop();
                let pantalla = $(window).height();
                let altoAside = $("#" + videoid).parent().height();
                $("#" + videoid).parent().css({ "min-height": altoAside, "background-color": "#ddd" });

                //Si se visualiza o no en el WindowsScreen
                if (documento + pantalla < limiteTop || documento > limiteBottom) {
                    VideoFixed();
                } else {
                    VideoDefault();
                }

                //Termina el video y finaliza la funcion Fixed
                jwplayer(videoid).on('complete', function() {
                    VideoDefault();
                    videoid = 0;
                });
            }

        });
        //Boton cerrar FixedVideo
        $(".contenedor-video-fixed span:last-child").on("click", function() {
            let cerrarVideo = $(".jwplayer.fixedVideo").attr("id");
            if ($(".jwplayer.jw-flag-ads.jw-state-playing").length > 0) {
                jwplayer(cerrarVideo).pause();
            } else {
                jwplayer(cerrarVideo).stop();
            }
            $("#" + cerrarVideo + " .jw-skip").removeClass("omitirShow");
            $("#" + cerrarVideo + " .jw-skip").addClass("omitirHide");
            $("#" + cerrarVideo).addClass("animated slideOutDown");
            $(".contenedor-video-fixed").addClass("animated slideOutDown");

            function slideCerrar() {
                $("#" + cerrarVideo).removeClass("fixedVideo");
                $("#" + cerrarVideo).removeClass("animated slideOutDown");
                $(".contenedor-video-fixed").removeClass("animated slideOutDown");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + cerrarVideo).addClass("defaultVideo");
                cerrarVideo = 0;
            }
            setTimeout(slideCerrar, 500);
            videoid = 0;
        });

    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/functions.js